import {GetterTree} from 'vuex';
import {RootState} from '@/store';
import {ConversationsState} from '@/store/modules/Conversations/state';
import {AdvertConversation} from '#/Advert';
import {Conversation, Conversations} from '#/Conversations';

export const getters: GetterTree<ConversationsState, RootState> = {
    advertsConversation: (state: ConversationsState): AdvertConversation[] => state.advertsConversation,
    conversation: (state: ConversationsState): Conversation => state.conversation,
    conversations: (state: ConversationsState): Conversations => state.conversations,
    messageUnreadNumber: (state: ConversationsState): number => state.messageUnreadNumber,
};
